import type { ExitUnitSelection } from "../../../../../views/LogisticPark/RegistroIngreso/utils/exitPrefillUtils";
import { eventUserId, VehicleInsideRow } from "./vehicleInsideRow";

/**
 * Un acoplado no puede salir solo: si la selección lleva acoplados pero ningún tractor, hay que
 * cargar el que los viene a retirar.
 *
 * Vale para los dos modales de salida —el de la unidad y el de la persona—, así que vive acá y no
 * en el componente.
 */
export const requiereTractor = (selected: ExitUnitSelection[]): boolean =>
  selected.some((unit) => unit.role === "trailer") &&
  !selected.some((unit) => unit.role === "tractor");

/** Persona sobre la que se abrió el modal de salida, con lo mínimo para encontrar sus unidades. */
type PersonaConUnidades = {
  eventId?: string;
  userId?: string;
  dni?: string;
};

/**
 * Unidades que la persona tiene dentro del complejo, según `getVehiclesInside`.
 *
 * Se cruza por evento, por id de usuario y por documento. El evento es el criterio bueno —los ids
 * de cada vehículo se resuelven contra él—, pero no siempre alcanza: el endpoint puede devolver el
 * evento sin poblar, y ahí `eventId` viene vacío.
 *
 * A propósito **no** hay plan B contra el evento de ingreso: esa es una foto de cuando entró, no de
 * si la unidad sigue adentro. Si `getVehiclesInside` no encuentra nada, es porque no hay nada
 * adentro —ya salió, quizás con otro chofer— y hay que respetar eso, no inventar unidades para
 * ofrecer.
 */
export const unidadesDePersona = (
  rows: VehicleInsideRow[],
  persona: PersonaConUnidades
): VehicleInsideRow[] =>
  (rows ?? []).filter((row) => {
    if (persona.eventId && row.eventId === persona.eventId) return true;
    if (persona.userId && eventUserId(row) === persona.userId) return true;
    return Boolean(persona.dni) && row.driver?.dni === persona.dni;
  });
